/* 最近浏览 —— sections/recently-viewed.liquid

   存储：localStorage 'thehues.recentlyViewed.v1' = ['handle', ...]，最新在前，最多 12 个。
   只存 handle，不存标题/价格/图片：价格随活动变、B2B 客户看到的价也不一样，
   缓存下来的卡片会过期说错话。卡片每次都由服务端按当前价渲染。

   取卡片：滚动接近（提前 1500px，PDP 很长，提前量用来吃掉约 1.7s 的渲染耗时）才发**一次**请求，Section Rendering API 按文件名渲染
   recently-viewed，handle 列表放在 q 里（见 section 顶部注释）。
   首屏不受影响：这个 section 在产品页最底部，没有可显示的就一直 hidden，不占位。

   localStorage 在隐私模式/禁用站点数据时会抛错，所有读写都包 try/catch，
   失败就当没有历史 —— section 保持隐藏，页面其余部分不受影响。 */
(function () {
  const STORAGE_KEY = 'thehues.recentlyViewed.v1';
  const MAX_STORED = 12;
  const HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/;

  function readList () {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && HANDLE_RE.test(h); }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList (list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) { /* 存不了就算了 */ }
  }

  function remember (handle) {
    if (!handle || !HANDLE_RE.test(handle)) return;
    const list = readList().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeList(list);
  }

  // 已下架/删除的产品服务端不会出卡片；把它们从历史里清掉，下次不再白占名额。
  function prune (requested, returned) {
    if (!requested.length) return;
    const gone = requested.filter(function (h) { return returned.indexOf(h) === -1; });
    if (!gone.length) return;
    writeList(readList().filter(function (h) { return gone.indexOf(h) === -1; }));
  }

  const SEARCH_ATTRIBUTION = ['_pos', '_sid', '_ss', '_psq', '_fid', '_v'];
  function cleanHref (href) {
    const q = href.indexOf('?');
    if (q === -1) return href;
    const params = new URLSearchParams(href.slice(q + 1).replace(/\?/g, '&'));
    SEARCH_ATTRIBUTION.forEach(function (k) { params.delete(k); });
    const rest = params.toString();
    return href.slice(0, q) + (rest ? '?' + rest : '');
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback () {
      if (this.dataset.bound) return;
      this.dataset.bound = '1';

      const current = this.dataset.current || '';
      const limit = parseInt(this.dataset.limit, 10) || 8;

      // 先读历史再记当前：当前产品不出现在自己的"最近浏览"里
      this.handles = readList().filter(function (h) { return h !== current; }).slice(0, limit);
      if (current) remember(current);

      if (!this.handles.length) return; // 没有可显示的，保持 hidden，不发请求

      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        observer.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 1500px 0px' });
      // hidden 元素没有盒子，观察不到；观察它的 section 外壳
      observer.observe(this.closest('.shopify-section') || this.parentElement);
    }

    load () {
      const handles = this.handles;
      const url = this.dataset.url + '+' + handles.map(encodeURIComponent).join('+');

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const list = doc.querySelector('.recently-viewed__list');
          // 429 人机验证页也是 200 以外/或是一整页 HTML —— 认不出列表就什么都不做
          if (!list) return;

          const items = Array.prototype.slice.call(list.querySelectorAll('.recently-viewed__item'));
          prune(handles, items.map(function (li) { return li.dataset.handle; }));
          if (!items.length) return;

          // 按浏览先后排（服务端按 q 的顺序出，这里再保险一次）
          items.sort(function (a, b) { return handles.indexOf(a.dataset.handle) - handles.indexOf(b.dataset.handle); });
          list.replaceChildren.apply(list, items);

          // 卡片是在搜索页上下文里渲染的，click-data 前缀会带上搜索页标题；
          // 改成固定的模块名，GA4 里能单独看出"最近浏览"带来的点击。
          // 卡片是在搜索页上下文里渲染的，Shopify 会给结果里的产品链接插上搜索归因参数
          // ?_pos=1&_sid=…&_ss=r —— 插在路径后面，于是卡片自己拼的 ?selectcolor=Cream 变成第二个 ?，
          // 整段成了 _ss 的值，PDP 读不到 selectcolor，落地和加购都是默认色（review P1 复现过）。
          // 这里不是真搜索，归因参数本来也不该带（会把点击记到一次假搜索上），整体去掉，
          // 第二个 ? 当 & 处理，其余参数（selectcolor / ref …）原样保留。
          items.forEach(function (li) {
            li.querySelectorAll('[href*="_sid="], [href*="_pos="]').forEach(function (a) {
              a.setAttribute('href', cleanHref(a.getAttribute('href')));
            });
          });

          // 标题从 li 的 data-title 取，不去解析原值 —— 原值里的搜索页标题含 handle，满是连字符。
          items.forEach(function (li) {
            li.querySelectorAll('[click-data^="pCard_"]').forEach(function (el) {
              el.setAttribute('click-data', 'pCard_RecentlyViewed-' + (li.dataset.title || li.dataset.handle));
            });
          });

          const target = this.querySelector('[data-recently-viewed-target]');
          if (!target) return;
          target.replaceChildren(document.importNode(list, true));
          this.hidden = false;

          // 色块换图 / hover 第二张图：和 facets / load-more 补插卡片同一个入口
          if (typeof window.colorSwatches === 'function') window.colorSwatches(target);
        })
        .catch(function () { /* 网络/限流失败：保持隐藏 */ });
    }
  }

  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
})();
